import React from "react";
import { getLabelStringWithHighlightedPart } from "../utils";

interface Props {
  suggestion: string;
  inputValue: string;
  shouldBold?: boolean;
}

const getBoldedParts = (suggestion: string, inputValue: string) => {
  const { beforeHighlightedPart, highlightedPart, afterHighlightedPart } =
    getLabelStringWithHighlightedPart(suggestion, inputValue);
  return [
    beforeHighlightedPart,
    <strong key={highlightedPart}>{highlightedPart}</strong>,
    afterHighlightedPart
  ];
};

const AutosuggestStringLabel = ({
  suggestion,
  inputValue,
  shouldBold = true
}: Props) => (
  <div className={"search-autosuggest__option"}>
    <div className={"search-autosuggest__option__title"}>
      {shouldBold ? getBoldedParts(suggestion, inputValue) : [suggestion]}
    </div>
  </div>
);

export default AutosuggestStringLabel;
